import React, { useEffect, useState } from "react";

import Login from "../../Components/Login";
import Otp from "../../Components/Otp";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearProcessData } from "../../redux/actions/processAction";
import { logo } from "../../assets/images";

export default function LoginPage() {
  const dispatch = useDispatch();
  const [showOtp, setShowOtp] = useState(false);
  const [credentials, setCredentials] = useState("");

  useEffect(() => {
    dispatch(clearProcessData());
  },[])// eslint-disable-line

  return (
    <div className="loginPage">
      <div className="loginCard">
        <div className="text-center">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <h2 className="text-center">Login</h2>
        {!showOtp && <p>
          Apply for new membership? <Link to="/register/user/select-membership">Click Here</Link>
        </p>}
        {showOtp ?
        <Otp
          onBack={() => setShowOtp(false)}
          credentials={credentials}
        />
        : <Login
          onNext={(email) => {
            setShowOtp(true);
            setCredentials(email);
          }}
        />}
      </div>
    </div>
  );
}
